<template>
  <div>
    <Header headerStyle='sub' :fixed-header='true' />
    <section class='sub terms'>
      <div class='sub__header'>
        <h1 class="title title--h1 title--center">
          이용약관
        </h1>
        <div class="breadcrumb">
          <span class="breadcrumb__depth">
            홈 >
          </span>
          <span class="breadcrumb__current">
            이용약관
          </span>
        </div>
      </div>
      <div class='sub__contents'>
        <h2 class='notice-top-title'>기프티엘 서비스 이용약관</h2>
        <div class='list-container'>
          <!-- <Spinner size="30" v-if="loading" /> -->
          <h3>[목차]</h3>
          <ul class="column-list">
            <li>제1조 목적</li>
            <li>제2조 용어의 정리</li>
            <li>제3조 약관의 효력 및 변경</li>
            <li>제4조 약관 외 준칙</li>
            <li>제5조 이용계약의 성립</li>
            <li>제6조 이용제한</li>
            <li>제7조 서비스 이용시간</li>
            <li>제8조 서비스 이용에 대한 이용자의 의무와 책임</li>
            <li>제9조 연계서비스</li>
            <li>제10조 기프티엘 전송 및 구매내역 관리</li>
            <li>제11조 기프티엘의 사용</li>
            <li>제12조 기프티엘의 사용제한</li>
            <li>제13조 회사의 의무</li>
            <li>제14조 이용자의 의무</li>
            <li>제15조 이용자에 대한 통지</li>
            <li>제16조 회원의 ID 및 비밀번호에 대한 의무</li>
            <li>제17조 주문취소 및 환불</li>
            <li>제18조 손해배상</li>
            <li>제19조 회사의 의무</li>
            <li>제20조 양도금지</li>
            <li>제21조 면책사항</li>
            <li>제22조 관할법원</li>
            <li>부칙</li>
          </ul>
          <h4>제 1조 (목적)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">이 서비스 약관은 스푼 주식회사(이하 “회사”라 함)이 제공하는 기프티엘 서비스를 이용자가 이용함에 있어 필요한 이용자와 회사간의 권리 및 의무 기타 제반 사항을 규정함을 목적으로 합니다.</li>
          </ul>
          <h4>제 2조 (용어의 정의)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-bottom-title">
              1. 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
              <ul class="list-ul-bottom">
                <li class="list-ul-bottom-li">① “기프티엘 서비스”(이하 “서비스”라 합니다)라 함은 회사가 직접 또는 제휴를 통하여 실물 상품을 구매 및 선물할 수 있는 모바일쿠폰 서비스를 말합니다.</li>
                <li class="list-ul-bottom-li">② “이용자”라 함은 본 약관에 따라 회사가 제공하는 서비스를 제공받아 서비스를 이용하는 구매자(전송자), 수신자를 말합니다.</li>
                <li class="list-ul-bottom-li">③ ”구매자(전송자)”라 함은 “기프티엘”을 구매하여 수신자에게 전송한 자를 말합니다.</li>
                <li class="list-ul-bottom-li">④ “수신자”라 함은 기프티엘을 이용자로부터 전송 받은 자를 말합니다.</li>
                <li class="list-ul-bottom-li">⑤ “교환처”라 함은 기프티엘을 실제 상품으로 교환할 수 있는 매장을 말합니다.</li>
                <li class="list-ul-bottom-li">※⑥ “기프티엘”이라 함은 교환처에서 판매하는 일정한 상품을 구매자(전송자)가 유무선 인터넷 사이트의 서비스를 통해 쿠폰을 구매하고, 이 교환권을 수신자가 해당 교환처에서 연계된 상품으로 교환할 수 있는 교환권을 말합니다.</li>
              </ul>
            </li>
            <li class="list-ul-bottom-title">2. 이 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외 하고는 관계법령, 상관례 및 서비스별 안내에서 정하는 바에 의합니다.</li>
          </ul>
          <h4>제 3조 (약관의 효력 및 변경)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 이 약관의 내용은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지하고, 이에 동의한 이용자가 서비스를 이용함으로써 효력이 발생합니다.</li>
            <li class="list-ul-top-li">2. 회사는 필요하다고 인정되는 경우 이 약관을 변경할 수 있으며, 약관이 변경된 경우에는 지체 없이 제1항과 같은 방법으로 공지합니다. 다만, 이용자의 권리 또는 의무에 관한 중요한 규정의 변경은 최소한 30일전에 공지합니다.</li>
          </ul>
          <h4>제 4조 (약관 외 준칙)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">이 약관은 회사가 제공하는 서비스 안내와 함께 적용됩니다. 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 대한민국의 관계법령 또는 상관습에 따릅니다.</li>
          </ul>
          <h4>제 5조 (이용계약의 성립)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 서비스 이용 시 약관을 읽고 “동의합니다”에 체크한 후 확인버튼을 클릭하면 약관에 동의하는 것으로 간주됩니다.</li>
            <li class="list-ul-top-li">2. 이용계약은 이용자의 이용신청에 대해 회사가 승낙함으로써 성립합니다.</li>
          </ul>
          <h4>제 6조 (이용제한)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-bottom-title">
              1. 회사는 다음 각 호에 해당하는 경우 이용자에게 기프티엘 전송을 제한하거나 중단할 수 있습니다.
              <ul class="list-ul-bottom">
                <li class="list-ul-bottom-li">① 서비스용 설비의 장애 및 보수, 정전, 이용량의 폭주 등 기술상 서비스 제공이 불가능한 경우</li>
                <li class="list-ul-bottom-li">② 이용자가 타인 명의로 서비스를 이용하는 경우</li>
                <li class="list-ul-bottom-li">③ 회사의 서비스 정책 또는 본 이용약관에 위반하여 서비스를 이용하고자 하는 경우</li>
                <li class="list-ul-bottom-li">④ 서비스의 System을 무단으로 침범한 경우 </li>
                <li class="list-ul-bottom-li">⑤ 기타 회사가 정한 요건을 충족하지 아니한 경우 </li>
                <li class="list-ul-bottom-li">⑥ 외국인 이용자의 경우 </li>
                <li class="list-ul-bottom-li">⑦ 이동전화 서비스 가입자의 자격 또는 성격에 따라 이동전화 서비스의 해지, 일시정지, 정보이용료 한도 초과 등의 사유가 발생한 경우 </li>
              </ul>
            </li>
            <li class="list-ul-bottom-title">2. 본 조에 따른 서비스 제한이나 중단의 경우에는 그 사유와 일정을 서비스 화면에 게재하거나 휴대폰 SMS등을 통하여 이용자에게 통지합니다. 다만, 회사가 통제할 수 없는 사유로 인한 서비스의 중단(회사의 고의, 과실이 없는 디스크장애, 시스템다운 등)으로 인하여 사전 통지가 불가능한 경우에는 그러하지 아니합니다.</li>
          </ul>
          <h4>제 7조 (서비스 이용시간)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 다만, 회사의 업무상이나 기술상의 이유로 서비스가 일지 중지될 수 있고, 또한 운영 상의 목적으로 회사가 정한 기간에는 서비스가 일시 중지 될 수 있습니다. 이러한 경우 회사는 사전에 이를 공지하며, 부득이한 경우 사후 통보할 수 있습니다.</li>
            <li class="list-ul-top-li">2. 회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용 가능한 시간을 별도로 정할 수 있으며 이 경우 그 내용을 공지합니다.</li>
          </ul>
          <h4>제 8조 (서비스 이용에 대한 이용자의 의무와 책임)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">회사가 정상적으로 서비스를 제공한 경우 이로 인해 발생하는 개인간의 모든 민•형사상 분쟁에 대한 책임은 이용자에게 있습니다.</li>
          </ul>
          <h4>제 9조 (연계서비스)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 해당 서비스 이용을 위해 필요한 유무선 인터넷 사이트의 서비스는 해당 서비스의 약관과 서비스 정책에 따릅니다.</li>
            <li class="list-ul-top-li">2. 제1항의 연계 서비스의 서비스 정책, 회원정책, 서비스 장애 통지 등은 각각의 서비스 운영 주체에서 책임을 지며 회사에서는 서비스의 제공에 대한 부분만 책임을 집니다.</li>
          </ul>
          <h4>제 10조 (기프티엘 전송 및 구매내역 관리)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 기프티엘의 구매내역과 수신내역은 고객센터를 통해 그 내용을 확인할 수 있습니다.</li>
            <li class="list-ul-top-li">2. 이용자의 고의 또는 과실로 기프티엘 전송내역 또는 수신내역이 노출되어 발생하는 손해에 대해 회사는 책임을 지지 않습니다.</li>
          </ul>
          <h4>제 11조 (기프티엘의 사용)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 기프티엘의 지정된 상품이 일부 교환처에서 품절일 경우가 있으며 이에 대해서는 회사에서 책임지지 않습니다.</li>
            <li class="list-ul-top-li">2. 구매시 성명 및 이동전화번호를 이용자가 잘못 입력하여 기프티엘이 오전송 된 후 수신자에 의해 쿠폰이 교환된 경우, 회사에서는 이에 대해 책임지지 않습니다. 단, 쿠폰이 교환 되기 전에 이용자가 고객센터를 통해 오전송 정정 신청을 할 경우 수신자를 정정 하여 전송할 수 있습니다.</li>
            <li class="list-ul-top-li">3. 기프티엘을 수신한 수신자가 기프티엘을 삭제한 경우 회사는 유선상으로 고객센터로 문의하여 이를 재 다운로드 받을 수 있도록 할 수 있습니다. </li>
            <li class="list-ul-top-li">4. 기프티엘은 발행일로부터 쿠폰에 명시된 상품의 유효기간 동안 교환처에서 상품을 교환할 수 있습니다. </li>
            <li class="list-ul-top-li">5. 기프티엘은 결제일로부터 금액권은 366일, 제품교환권은 93일, 시즌제품의 경우 93일의 기간(이하 “유효기간) 동안 유효하며, 수신자는 해당 기간 동안 쿠폰을 교환처에서 사용할 수 있습니다. 다만, 수신자는 유효기간 만료 전(금액권 366일, 제품교환권 93일)까지 2회에 한해 회사에게 유효기간 연장을 요청할 수 있으며, 회사는 사전에 고객에게 유효기간 연장 및 기간연장 불가 고지를 한 경우와 같이 특별한 사정이 없는 한 이에 응하여야 합니다.</li>
            <li class="list-ul-top-li">6. 프로모션 상품, 시즌성 상품 등 특정한 목적의 기프티엘의 경우에는 본조 5항이 적용되지 않습니다.</li>
          </ul>
          <h4>제 12조 (기프티엘의 사용 제한)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-bottom-title">
              1. 회사는 다음 각 호에 해당하는 경우 수신자가 수신한 기프티엘의 전부 또는 일부에 대하여 교환을 제한하거나 사용을 중지할 수 있습니다.
              <ul class="list-ul-bottom">
                <li class="list-ul-bottom-li">① 교환처와의 계약 종료 등과 같은 회사의 제반 사정으로 서비스를 유지할 수 없는 경우</li>
                <li class="list-ul-bottom-li">② 회사가 제공하는 서비스가 아닌 불법 또는 부정한 방법, 다른 수신자로부터 기프티엘 및 쿠폰 번호를 재송신 받아 교환하고자 하는 경우</li>
                <li class="list-ul-bottom-li">③ 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우 </li>
                <li class="list-ul-bottom-li">④ 기타 본 약관에서 정한 기프티엘의 교환 제한 사유가 발생한 경우</li>
              </ul>
            </li>
            <li class="list-ul-bottom-title">2. 기프티엘이 전산상의 문제 또는 기타 회사의 귀책사유로 인하여 교환할 수 없는 경우가 발생할 경우 회사는 교환이 불가능했던 기간만큼 기프티엘의 유효기간을 연장하거나 환불규정에 따라 기프티엘을 환불해 줍니다.</li>
          </ul>
          <h4>제 13조 (회사의 의무)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 회사는 서비스와 관련한 이용자의 불만사항이 접수되는 경우 이를 신속하게 처리하여야 하며, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 서비스 화면에 게재하거나 휴대폰 SMS 등을 통하여 동 이용자에게 통지합니다.</li>
            <li class="list-ul-top-li">2. 회사가 서비스를 제공하는 과정에서 회사의 고의 또는 과실로 인하여 이용자에게 손해가 발생한 경우 회사는 이용자에게 손해를 배상합니다.</li>
            <li class="list-ul-top-li">3. 회사는 정보통신망 이용촉진 및 정보보호에 관한 법률, 통신비밀보호법, 전기통신사업법, 전자상거래법 등 서비스의 운영, 유지와 관련 있는 법규를 준수합니다.</li>
          </ul>
          <h4>제 14조 (이용자의 의무)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-bottom-title">
              1. 이용자는 서비스를 이용할 때 다음 각 호의 행위를 하여서는 아니 됩니다.
              <ul class="list-ul-bottom">
                <li class="list-ul-bottom-li">① 부정하게 서비스에 접속하여 사용하는 행위</li>
                <li class="list-ul-bottom-li">② 회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위</li>
                <li class="list-ul-bottom-li">③ 회사의 저작권 또는 제3자의 지적재산권 등 기타 권리를 침해하는 행위</li>
                <li class="list-ul-bottom-li">④ 공공질서 및 미풍양속에 위반되는 내용 등을 타인에게 유포하는 행위</li>
                <li class="list-ul-bottom-li">⑤ 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보 및 수신자의 명시적인 수신거부의사에 반하여 광고성 정보를 전송하는 행위</li>
                <li class="list-ul-bottom-li">⑥ 서비스에 게시된 정보를 변경하는 행위</li>
                <li class="list-ul-bottom-li">⑦ 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위</li>
                <li class="list-ul-bottom-li">⑧ 회사의 직원이나 서비스 운영자를 가장하거나 사칭하여 SMS 발송 또는 연락을 취하는 행위</li>
                <li class="list-ul-bottom-li">⑨ 스토킹(stalking) 등 다른 이용자를 괴롭히는 행위</li>
                <li class="list-ul-bottom-li">⑩ 기타 불법적이거나 부당한 행위</li>
              </ul>
            </li>
            <li class="list-ul-bottom-title">2. 이용자는 관계 법령, 본 약관의 규정, 서비스별 안내 및 서비스상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다.</li>
          </ul>
          <h4>제 15조 (이용자에 대한 통지)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 이용자에 대한 통지를 하는 경우 회사는 이용자가 제공한 E-mail 주소 또는 SMS 등으로 할 수 있습니다.</li>
            <li class="list-ul-top-li">2. 회사는 불특정 다수 이용자에 대한 통지의 경우 서비스 게시판 등에 게시함으로써 개별 통지에 갈음할 수 있습니다.</li>
          </ul>
          <h4>제 16조 (주문취소 및 환불)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-bottom-title">
              1. 구매자는 다음 각 호의 사유에 해당하는 경우 상품 유효기간 내에서 기프티엘의 수신자가 기프티엘을 교환처에서 교환하지 않은 경우 주문을 취소할 수 있으며, 이 경우 회사는 구매자가 결제한 전액을 환불합니다.
              <ul class="list-ul-bottom">
                <li class="list-ul-bottom-li">① 기프티엘 전송 시 시스템적인 장애 또는 해당 번호가 결번이거나 서비스되고 있지 않음으로 인해 영구적으로 수신자에게 메시지 -  (카카오도 있음)가 정상적으로 발송되지 않는 경우</li>
                <li class="list-ul-bottom-li">② 주문 시 Network 문제로 인해 결제만 수행되고 정상적으로 발송단계를 거치지 못한 경우</li>
              </ul>
            </li>
            <li class="list-ul-bottom-title">2. 수신자의 전화번호를 전송자가 잘못 입력하여 기프티엘 쿠폰이 오발송된 후 제3자인수신자에 의해 사용된 경우 회사에서는 전송자의 오발송에 대해 책임지지 않습니다.</li>
            <li class="list-ul-bottom-title">3. 기프티엘 쿠폰은 유효기간 동안 해당 사용처에서 사용하지 않는 경우 유효기간 이후 재사용할 수 없으며 연장, 취소 또는 환불이 되지 않습니다.</li>
            <li class="list-ul-bottom-title">4. 회사와 타 회사 간의 약정을 통해 발송되거나 프로모션 또는 이벤트 경품으로 무상 제공된 기프티엘쿠폰은 유효기간 연장 및 환불이 불가 하며, 본 조의 규정이 적용되지 않습니다.</li>
            <li class="list-ul-bottom-title">5. 상품 유효기간 내에 수신자가 사용하지 않은 기프티엘의 경우 웹사이트 내 환불 접수 코너를 통하여 환불 요청을 하실 수 있습니다.</li>
          </ul>
          <h4>제 17조 (손해 배상)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 이용자가 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 이 약관을 위반한 이용자는 회사에 발생하는 손해를 배상하여야 합니다.</li>
            <li class="list-ul-top-li">2. 이용자는 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반 행위로 인하여 회사가 당해 이용자 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 이용자는 자신의 책임과 비용으로 회사를 면책 시켜야 하며, 회사가 면책되지 못 한 경우 당해 이용자는 그로 인하여 회사에 발생한 손해를 배상하여야 합니다.</li>
          </ul>
          <h4>제 18 조(회사의 의무)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">① 회사는 기프티엘 서비스를 제공함에 있어서 전자상거래등에서의 소비자보호에 관한 법률, 소비자기본법, 정보통신망이용촉진 및 정보보호 등에 관한 법률, 표시∙광고의 공정화에 관한 법률, 여신전문 금융업법 등 관련법령 및 이 약관을 준수합니다.</li>
            <li class="list-ul-top-li">② 회사는 관련법령과 이 약관이 정하는 바에 따라 이용자에게 안정적인 서비스를 제공하기 위해 기술적∙관리적으로 필요한 조치를 취합니다. </li>
          </ul>
          <h4>제 19조 (양도금지)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">이용자 및 회사는 본 약관상의 지위 또는 권리ㆍ의무의 전부 또는 일부를 제3자에게 양도, 위임하거나 담보제공 등의 목적으로 처분할 수 없습니다.</li>
          </ul>
          <h4>제 20조 (면책사항)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-bottom-title">1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
            <li class="list-ul-bottom-title">2. 회사는 이용자의 귀책사유로 인한 서비스의 이용장애에 대하여 책임을 지지 않습니다.</li>
            <li class="list-ul-bottom-title">
              3. 회사는 다음 각 호에서 예시하는 바와 같이 불법 또는 부정한 방법으로 서비스를 이용하여 이용자 상호간 또는 이용자와 제3자 상호간에 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.
              <ul class="list-ul-bottom">
                <li class="list-ul-bottom-li">① 타인의 휴대전화(분실된 전화 포함)를 이용하거나 번호를 도용하여 기프티엘을 구매한 경우</li>
                <li class="list-ul-bottom-li">② 이용자가 수신자의 번호를 잘못 입력하여 기프티엘을 잘못 전송 하였는데, 수신자가 기프티엘을 이미 사용하였거나 반환을 거절하는 경우</li>
              </ul>
            </li>
          </ul>
          <h4>제 21조(관할법원)</h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">1. 서비스 이용과 관련하여 회사와 이용자 사이에 분쟁이 발생한 경우, 회사와 이용자는 분쟁의 해결을 위해 성실히 협의합니다.</li>
            <li class="list-ul-top-li">2. 본 조 제1항의 협의에서도 분쟁이 해결되지 않을 경우 양 당사자는 민사소송법상의 관할법원에 소를 제기할 수 있습니다.</li>
            <li class="list-ul-top-li">3. 서비스 이용 및 본 약관과 관련하여 발생하는 분쟁에 대해서는 대한민국의 법률을 적용합니다.</li>
          </ul>
          <h4>부칙 </h4>
          <ul class="list-ul-top">
            <li class="list-ul-top-li">이 약관은 2025년 01월 02일부터 적용됩니다.</li>
          </ul>
        </div>
      </div>
      <TermsList />
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import Header from '@/components/Header';
import Spinner from '@/components/Spinner';
import TermsList from '@/components/TermsList';

require('es6-promise').polyfill();

export default {
  components: {
    Header,
    Spinner,
    TermsList
  },
  data() {
    return {
      loading: true,
      selectData: [],
      body: {}
    };
  },
  async created() {
    try {
      // 셀렉트박스 데이터 조회
      await axios
        .post(`${process.env.API_URL}/terms/day`, {
          ntro_se_code: '000001'
        })
        .then(res => {
          const {
            data: {
              return_cd,
              response: { data }
            }
          } = res;

          if (return_cd === '0000' && data.length > 0) {
            this.selectData = data;
          } else {
            this.body = {
              ntro_bdt: '조회된 데이터가 없습니다.'
            };
            this.loading = false;
          }
        })
        .catch(err => {
          console.log(err);
          this.body = {
            ntro_bdt: '조회된 데이터가 없습니다.'
          };
          this.loading = false;
        });

      // 셀렉트박스 데이터 조회 기준 최근 날짜 조회
      await axios
        .post(`${process.env.API_URL}/terms`, {
          ntro_se_code: '000001',
          ntro_wrt_pit: this.selectData[0].ntro_wrt_pit
        })
        .then(res => {
          const {
            data: {
              return_cd,
              response: { data }
            }
          } = res;
          if (return_cd === '0000' && data !== null) {
            this.body = data;
          } else {
            this.body = {
              ntro_bdt: '조회된 데이터가 없습니다.'
            };
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.body = {
            ntro_bdt: '조회된 데이터가 없습니다.'
          };
          this.loading = false;
        });
    } catch (err) {
      console.log(err);
    }
  }
};
</script>

<style scoped lang='scss'>
@import "@/assets/styles/mixin.scss";
.terms {
  padding-top: 100px;
  width: 1140px;
  margin: 0 auto;
  letter-spacing: -0.05em;
}
.notice-top-wrap {
  width: 100%;
  margin-bottom: 10px;
  @include flexbox();
  @include justify-content(space-between);
  .notice-top-title {
    font-size: 18px;
    color: #222;
    vertical-align: center;
  }
  .select-wrap {
    width: 165px;
    vertical-align: center;
    select {
      font-size: 15px;
      color: #666;
      padding: 3px 52px 5px 10px;
      margin-left: -16px;
      height: 30px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background: url(../assets/images/btn-select.png) no-repeat 95% 50%;
      &::-ms-expand{
        display: none;
      }
    }
  }
}
.list-container {
  border-top: 1px solid #e6e6e6;
  padding-top: 30px;
  .list-top-normal {
    font-size: 16px;
    color: #666;
    line-height: 34px;
    margin-bottom: 52px;
  }
  h3 {
    margin-bottom: 13px;
    font-size: 22px;
    color: #222;
    font-weight: bold;
  }
  h4 {
    margin-bottom: 13px;
    font-size: 18px;
    color: #222;
    font-weight: bold;
  }
  .list-ul-top {
    margin-bottom: 50px;
    li {
      font-size: 16px;
      color: #666;
      line-height: 34px;
      &.list-ul-top-p {
        margin-bottom: 23px;
      }
      &.list-ul-bottom-title {
        color: #222;
        .list-ul-bottom {
          margin: 4px 0 23px 19px;
          li {
            font-size: 15px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
.column-list{
  margin-bottom:50px;
  li{
    font-size:18px;
    margin-top:18px;
  }
}
.table{
  width:100%;
  margin-top:10px;
  thead{
    th{
      border:1px solid #ebeef5;
      background:#fafafa;
      text-align:center;
    }
  }
  tbody{
    td{
      padding:5px 10px;
      border:1px solid #ebeef5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Terms.vue